// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

* {
  box-sizing: border-box;
}

/* Desktop styles */
@media (min-width: 768px) {
  .mobile-header {
    display: none !important;
  }
  
  .sidebar-overlay {
    display: none !important;
  }
  
  .dashboard-sidebar {
    position: static !important;
    transform: translateX(0) !important;
  }

  .main-content {
    margin-left: 256px !important;
    padding-top: 0 !important;
  }
}

/* Tablet and Mobile styles */
@media (max-width: 767px) {
  .mobile-header {
    display: flex !important;
  }

  .main-content {
    margin-left: 0 !important;
  }
}

/* Extra small screens - Card layout */
@media (max-width: 480px) {
  .mobile-card {
    padding: 0 !important;
  }

  .mobile-card table,
  .mobile-card thead,
  .mobile-card tbody,
  .mobile-card th,
  .mobile-card td,
  .mobile-card tr {
    display: block !important;
  }
  
  .mobile-card thead tr {
    position: absolute !important;
    top: -9999px !important;
    left: -9999px !important;
  }
  
  .mobile-card tbody tr {
    border: 1px solid #e5e7eb !important;
    margin-bottom: 12px !important;
    border-radius: 12px !important;
    padding: 16px !important;
    background: white !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    position: relative !important;
  }
  
  .mobile-card td {
    border: none !important;
    padding: 12px 0 !important;
    text-align: left !important;
    position: relative !important;
    padding-left: 0 !important;
    word-wrap: break-word !important;
    min-width: auto !important;
  }
  
  .mobile-card td:before {
    content: attr(data-label);
    font-weight: 600 !important;
    color: #374151 !important;
    display: block !important;
    margin-bottom: 4px !important;
    font-size: 11px !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
  }
  
  .mobile-card td > div {
    display: block !important;
    width: 100% !important;
  }
  
  .mobile-actions {
    flex-direction: row !important;
    flex-wrap: wrap !important;
    gap: 6px !important;
    padding-left: 0 !important;
    margin-top: 8px !important;
    justify-content: flex-start !important;
  }
  
  .mobile-actions button {
    flex: 0 1 auto !important;
    min-width: 44px !important;
    justify-content: center !important;
    padding: 10px !important;
  }
}

/* Tablet-specific adjustments */
@media (min-width: 481px) and (max-width: 767px) {
  .mobile-table th,
  .mobile-table td {
    padding: 12px !important;
    font-size: 13px !important;
  }
  
  .mobile-table th:first-child,
  .mobile-table td:first-child {
    min-width: 180px !important;
  }
}

.mobile-features {
  display: flex !important;
  gap: 6px !important;
  flex-wrap: wrap !important;
  align-items: center !important;
}

/* Modal responsive styles */
.responsive-modal {
  width: 95vw !important;
  max-width: none !important;
  margin: 10px !important;
  max-height: 85vh !important;
  padding: 16px !important;
}

.responsive-form-grid {
  grid-template-columns: 1fr !important;
  gap: 12px !important;
}

.responsive-button-group {
  flex-direction: column !important;
  gap: 8px !important;
}

.responsive-button-group button {
  width: 100% !important;
}

/* Search input responsive */
.search-container {
  width: 100% !important;
  margin-bottom: 16px !important;
}

/* User/Room cards on very small screens */
.user-avatar {
  width: 32px !important;
  height: 32px !important;
}

.user-info h4 {
  font-size: 14px !important;
  margin: 0 0 2px 0 !important;
}

.user-info p {
  font-size: 12px !important;
  margin: 0 !important;
}

/* Landscape phone orientation */
@media (max-width: 767px) and (orientation: landscape) {
  .main-content {
    padding-top: 60px !important;
  }
  
  .responsive-modal {
    max-height: 80vh !important;
  }
}

/* High DPI displays */
@media (min-resolution: 192dpi) {
  .mobile-table {
    font-size: 13px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,SAAS;EACT,gFAAgF;AAClF;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;IAC3B,mCAAmC;EACrC;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,qBAAqB;EACvB;;EAEA;;;;;;IAME,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,oCAAoC;IACpC,8BAA8B;IAC9B,8BAA8B;IAC9B,wBAAwB;IACxB,4BAA4B;IAC5B,mDAAmD;IACnD,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;IAC1B,gCAAgC;IAChC,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;IACzB,6BAA6B;IAC7B,0BAA0B;IAC1B,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,mBAAmB;IACnB,0BAA0B;IAC1B,0BAA0B;IAC1B,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,kCAAkC;IAClC,wBAAwB;EAC1B;AACF;;AAEA,gCAAgC;AAChC;EACE;;IAEE,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,0CAA0C;AAC1C;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* Desktop styles */\n@media (min-width: 768px) {\n  .mobile-header {\n    display: none !important;\n  }\n  \n  .sidebar-overlay {\n    display: none !important;\n  }\n  \n  .dashboard-sidebar {\n    position: static !important;\n    transform: translateX(0) !important;\n  }\n\n  .main-content {\n    margin-left: 256px !important;\n    padding-top: 0 !important;\n  }\n}\n\n/* Tablet and Mobile styles */\n@media (max-width: 767px) {\n  .mobile-header {\n    display: flex !important;\n  }\n\n  .main-content {\n    margin-left: 0 !important;\n  }\n}\n\n/* Extra small screens - Card layout */\n@media (max-width: 480px) {\n  .mobile-card {\n    padding: 0 !important;\n  }\n\n  .mobile-card table,\n  .mobile-card thead,\n  .mobile-card tbody,\n  .mobile-card th,\n  .mobile-card td,\n  .mobile-card tr {\n    display: block !important;\n  }\n  \n  .mobile-card thead tr {\n    position: absolute !important;\n    top: -9999px !important;\n    left: -9999px !important;\n  }\n  \n  .mobile-card tbody tr {\n    border: 1px solid #e5e7eb !important;\n    margin-bottom: 12px !important;\n    border-radius: 12px !important;\n    padding: 16px !important;\n    background: white !important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n    position: relative !important;\n  }\n  \n  .mobile-card td {\n    border: none !important;\n    padding: 12px 0 !important;\n    text-align: left !important;\n    position: relative !important;\n    padding-left: 0 !important;\n    word-wrap: break-word !important;\n    min-width: auto !important;\n  }\n  \n  .mobile-card td:before {\n    content: attr(data-label);\n    font-weight: 600 !important;\n    color: #374151 !important;\n    display: block !important;\n    margin-bottom: 4px !important;\n    font-size: 11px !important;\n    text-transform: uppercase !important;\n    letter-spacing: 0.5px !important;\n  }\n  \n  .mobile-card td > div {\n    display: block !important;\n    width: 100% !important;\n  }\n  \n  .mobile-actions {\n    flex-direction: row !important;\n    flex-wrap: wrap !important;\n    gap: 6px !important;\n    padding-left: 0 !important;\n    margin-top: 8px !important;\n    justify-content: flex-start !important;\n  }\n  \n  .mobile-actions button {\n    flex: 0 1 auto !important;\n    min-width: 44px !important;\n    justify-content: center !important;\n    padding: 10px !important;\n  }\n}\n\n/* Tablet-specific adjustments */\n@media (min-width: 481px) and (max-width: 767px) {\n  .mobile-table th,\n  .mobile-table td {\n    padding: 12px !important;\n    font-size: 13px !important;\n  }\n  \n  .mobile-table th:first-child,\n  .mobile-table td:first-child {\n    min-width: 180px !important;\n  }\n}\n\n.mobile-features {\n  display: flex !important;\n  gap: 6px !important;\n  flex-wrap: wrap !important;\n  align-items: center !important;\n}\n\n/* Modal responsive styles */\n.responsive-modal {\n  width: 95vw !important;\n  max-width: none !important;\n  margin: 10px !important;\n  max-height: 85vh !important;\n  padding: 16px !important;\n}\n\n.responsive-form-grid {\n  grid-template-columns: 1fr !important;\n  gap: 12px !important;\n}\n\n.responsive-button-group {\n  flex-direction: column !important;\n  gap: 8px !important;\n}\n\n.responsive-button-group button {\n  width: 100% !important;\n}\n\n/* Search input responsive */\n.search-container {\n  width: 100% !important;\n  margin-bottom: 16px !important;\n}\n\n/* User/Room cards on very small screens */\n.user-avatar {\n  width: 32px !important;\n  height: 32px !important;\n}\n\n.user-info h4 {\n  font-size: 14px !important;\n  margin: 0 0 2px 0 !important;\n}\n\n.user-info p {\n  font-size: 12px !important;\n  margin: 0 !important;\n}\n\n/* Landscape phone orientation */\n@media (max-width: 767px) and (orientation: landscape) {\n  .main-content {\n    padding-top: 60px !important;\n  }\n  \n  .responsive-modal {\n    max-height: 80vh !important;\n  }\n}\n\n/* High DPI displays */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .mobile-table {\n    font-size: 13px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
